import Component from '../Component';
import * as eventNames from '../../customEventStrings';

class LinkInternal extends Component {
	constructor(props) {
		super(props);
		this.key = this.props.id;
	}

	componentDidMount() {
		this.setupEventListeners();
	}

	setupEventListeners() {
		this.refs[`link-${this.key}`].addEventListener('click', (e) => {
			e.preventDefault();
			this.dispatchCustomEvent(eventNames.OPEN_MODAL, e.target, true, e.target.dataset);
		});
	}

	render() {
		return `
            <a href="#" ref="link-${this.key}" class="link" data-content-type="sidepanel" data-content-key="${this.props.id}">${this.props.text}</a>
        `;
	}
}

export default LinkInternal;
